import axiosInstance from '../api/index';
import request from '../api';
import { API_ROUTES } from '../consts';
import { RequestQueryBuilderParamsEnum } from '../consts/enums';
import { buildOrder, buildRequestParamsByType, buildSelect } from '../utils/request';
import PaginationResponseDto from '../interfaces/paginationResponse.interface';
// todo MATAN: combine with TALENTS_COMPANIES in talents api
export const getCompanies = async (query: ApiQuery): Promise<CompaniesResponse>  => {
  const { data } = await axiosInstance.get(API_ROUTES.TALENTS_COMPANIES, {
    params: {
      ...buildRequestParamsByType(query.contains || {}, RequestQueryBuilderParamsEnum.contains),
      select: buildSelect(query.select),
      page: query.page,
      limit: query.limit,
      order: buildOrder(query.order || {}),
    },
  });

  return data;
};

export const getAssociatedLinkedinCompany = async (
  linkedinUrl: string,
):Promise<Company> => {
  const { data } = await request.get(API_ROUTES.COMPANY_LINKEDIN, {
    params: {
      linkedinUrl,
    },
  });

  return data;
};

export const getCompaniesIndustries = async (
  query: ApiQuery,
):Promise<PaginationResponseDto<CompanyIndustry>> => {
  const { data } = await request.get(API_ROUTES.COMPANY_INDUSTRIES, {
    params: {
      ...buildRequestParamsByType(query.contains || {}, RequestQueryBuilderParamsEnum.contains),
      limit: query.limit,
    },
  });

  return data;
};
